import OnboardingCarousel from '@/modules/onboarding/OnboardingCarousel'
import { Stack } from 'expo-router'

export default function OnboardingPage() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <OnboardingCarousel />
    </>
  )
}
